import { render, staticRenderFns } from "./Note_Conflict_Preview.vue?vue&type=template&id=ef9bc31a"
import script from "./Note_Conflict_Preview.vue?vue&type=script&lang=js"
export * from "./Note_Conflict_Preview.vue?vue&type=script&lang=js"
import style0 from "./Note_Conflict_Preview.vue?vue&type=style&index=0&id=ef9bc31a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports